export default __webpack_public_path__ + "static/media/info.a7d17692.svg";